import React from 'react';

const TheNetGainsLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    data-testid="theNetGainsLogo"
    style={{
      fillRule: 'evenOdd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <rect
      id="Artboard1"
      x="0"
      y="0"
      width="200"
      height="50"
      style={{ fill: 'none' }}
    />
    <g id="Artboard11">
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M0,33.05L0,60.07C7.46,60.07 13.51,54.02 13.51,46.56C13.51,39.1 7.46,33.05 0,33.05Z"
          style={{ fill: 'rgb(255,128,49)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M59.66,27.41L59.66,0.39C52.2,0.39 46.15,6.44 46.15,13.9C46.15,21.36 52.2,27.41 59.66,27.41Z"
          style={{ fill: 'rgb(255,128,49)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M8.41,0.36L0,0.36L0,8.76L51.28,60.04L59.69,60.04L59.69,51.64L8.41,0.36Z"
          style={{ fill: 'rgb(255,128,49)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M76.88,16.27L76.88,8.56L74.97,8.56L74.97,5.7L76.88,5.7L76.88,1.15L81.34,1.15L81.34,5.69L83.95,5.69L83.95,8.55L81.34,8.55L81.34,15.28C81.34,16.4 81.96,16.68 82.94,16.68C83.33,16.68 83.78,16.65 83.95,16.65L83.95,19.99C83.56,20.1 82.69,20.21 81.45,20.21C78.79,20.21 76.88,19.34 76.88,16.26L76.88,16.27Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M86.02,0L90.59,0L90.59,7.46L90.67,7.46C91.71,6.09 92.94,5.27 94.93,5.27C98.07,5.27 99.92,7.51 99.92,10.71L99.92,20.05L95.35,20.05L95.35,11.64C95.35,10.13 94.59,9.09 93.11,9.09C91.63,9.09 90.59,10.35 90.59,12.12L90.59,20.06L86.02,20.06L86.02,0Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M101.78,12.84C101.78,8.55 104.78,5.27 109.16,5.27C111.21,5.27 112.83,5.94 114.07,7.06C115.78,8.63 116.62,11.13 116.59,14.04L106.27,14.04C106.55,15.98 107.62,17.18 109.5,17.18C110.71,17.18 111.49,16.65 111.88,15.75L116.34,15.75C116.03,17.04 115.19,18.27 113.93,19.14C112.72,19.98 111.27,20.46 109.44,20.46C104.7,20.46 101.78,17.18 101.78,12.83L101.78,12.84ZM111.96,11.33C111.79,9.62 110.73,8.53 109.24,8.53C107.5,8.53 106.6,9.62 106.3,11.33L111.97,11.33L111.96,11.33Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M74.97,27.06L83.19,27.06L92.98,43.63C93.49,44.55 95.24,47.83 95.24,47.83L95.33,47.83C95.33,47.83 95.24,43.86 95.24,42.7L95.24,27.05L103.23,27.05L103.23,60.06L95.01,60.06L85.31,43.72C84.76,42.84 82.96,39.29 82.96,39.29L82.87,39.29C82.87,39.29 82.96,43.54 82.96,44.69L82.96,60.06L74.97,60.06L74.97,27.06Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M106.92,47.51C106.92,40.45 111.86,35.04 119.06,35.04C122.43,35.04 125.11,36.15 127.14,37.99C129.96,40.58 131.34,44.68 131.29,49.49L114.3,49.49C114.76,52.68 116.52,54.66 119.61,54.66C121.6,54.66 122.89,53.78 123.53,52.31L130.87,52.31C130.36,54.43 128.98,56.46 126.9,57.9C124.92,59.28 122.51,60.07 119.51,60.07C111.71,60.07 106.91,54.67 106.91,47.51L106.92,47.51ZM123.68,45.02C123.4,42.2 121.65,40.4 119.2,40.4C116.34,40.4 114.86,42.2 114.35,45.02L123.68,45.02Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M135.91,53.56L135.91,40.86L132.77,40.86L132.77,36.15L135.91,36.15L135.91,28.67L143.25,28.67L143.25,36.15L147.54,36.15L147.54,40.86L143.25,40.86L143.25,51.94C143.25,53.79 144.27,54.25 145.88,54.25C146.53,54.25 147.26,54.2 147.54,54.2L147.54,59.69C146.89,59.87 145.46,60.06 143.43,60.06C139.04,60.06 135.9,58.63 135.9,53.55L135.91,53.56Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M154.55,55.45C151.69,52.31 150.12,47.97 150.12,42.94C150.12,37.91 151.87,33.2 155.01,30.06C157.73,27.29 161.57,25.67 166.32,25.67C174.81,25.67 179.89,30.19 180.95,37.12L173.01,37.12C172.41,34.44 170.19,32.41 166.59,32.41C161.14,32.41 158.42,36.93 158.42,42.94C158.42,48.95 161.56,53.47 166.73,53.47C171.02,53.47 173.56,50.61 173.89,47.7L173.89,47.61L167.7,47.61L167.7,41.61L181.46,41.61L181.46,59.34L175.74,59.34L175.28,55.37L175.19,55.37C173.02,58.74 169.79,60.08 165.82,60.08C161.11,60.08 157.28,58.42 154.55,55.46L154.55,55.45Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M184.56,52.87C184.56,47.65 188.71,46.08 193.61,45.44C198.04,44.89 199.61,44.42 199.61,42.81C199.61,41.29 198.64,40.27 196.38,40.27C193.98,40.27 192.78,41.33 192.55,43.32L185.63,43.32C185.81,38.93 189.18,35.19 196.34,35.19C199.9,35.19 202.3,35.84 204,37.13C206.03,38.61 207,40.92 207,43.87L207,55.78C207,57.67 207.18,58.73 207.83,59.15L207.83,59.47L200.54,59.47C200.17,58.96 199.94,58.04 199.76,56.84L199.67,56.84C198.29,58.83 196.21,60.07 192.65,60.07C187.94,60.07 184.57,57.53 184.57,52.87L184.56,52.87ZM199.8,51.02L199.8,48.2C198.83,48.71 197.45,49.08 195.92,49.45C193.01,50.1 191.81,50.83 191.81,52.64C191.81,54.53 193.19,55.27 195.04,55.27C197.86,55.27 199.8,53.56 199.8,51.02Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M211.33,27.06L218.86,27.06L218.86,33.15L211.33,33.15L211.33,27.06ZM211.33,36.43L218.86,36.43L218.86,60.07L211.33,60.07L211.33,36.43Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M223.13,36.43L230.39,36.43L230.39,39.66L230.53,39.66C232.28,37.12 234.55,35.73 237.82,35.73C242.99,35.73 246.04,39.42 246.04,44.69L246.04,60.06L238.51,60.06L238.51,46.21C238.51,43.72 237.26,42.01 234.82,42.01C232.38,42.01 230.66,44.09 230.66,47L230.66,60.07L223.13,60.07L223.13,36.43Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
      <g transform="matrix(0.553567,0,0,0.553567,25,8.37085)">
        <path
          d="M248.71,51.67L255.83,51.67C256.11,54.03 257.68,55.18 260.17,55.18C262.43,55.18 263.86,54.35 263.86,52.82C263.86,50.7 261,50.47 257.86,49.91C253.75,49.22 249.37,48.11 249.37,42.57C249.37,37.58 253.99,35 259.57,35C266.26,35 269.87,37.91 270.23,42.57L263.31,42.57C263.03,40.45 261.6,39.8 259.52,39.8C257.67,39.8 256.24,40.49 256.24,41.97C256.24,43.63 258.92,43.86 261.92,44.42C266.07,45.11 270.97,46.17 270.97,52.22C270.97,57.39 266.4,60.07 260.21,60.07C253.29,60.07 248.95,56.88 248.71,51.67Z"
          style={{ fill: 'rgb(33,33,33)', fillRule: 'nonzero' }}
        />
      </g>
    </g>
  </svg>
);

export default TheNetGainsLogo;
